export default "assets/images/included-6be64c98.svg";